module.exports = __webpack_public_path__ + "img/forage3.14d737b8.png";